/* eslint-disable */
export const initYoumeng = () => {
  if (window.location.host !== import.meta.env.VITE_YOUMENG_DOMAIN) {
    return;
  }
  var _czc: any = _czc || [];
  (function () {
    const um = document.createElement('script');
    um.src = `https://v1.cnzz.com/z.js?id=${import.meta.env.VITE_YOUMENG_ID}&async=1`;
    document.body.append(um);
  })();
};
/* eslint-enable */

/**
 * 处理小于10的数字
 * @param num
 * @returns
 */
export const formatLessThan10Num = (num: number): string => {
  return num < 10 ? `0${num}` : `${num}`;
};

/**
 * 获取最近几分钟时间
 * @param num
 * @returns
 */
export const getLastFewMinutes = (num = 5) => {
  const time = new Date();
  const year = time.getFullYear();
  const month = formatLessThan10Num(time.getMonth() + 1);
  const date = formatLessThan10Num(time.getDate());
  const hour = formatLessThan10Num(time.getHours());
  const minute = time.getMinutes();
  const lastFewminute = formatLessThan10Num(minute - (minute % num));
  return `${year}${month}${date}${hour}${lastFewminute}`;
};

/**
 * 获取url上的query参数
 * @returns
 */
export const getUrlQuery = () => {
  const search = window.location.search.replace('?', '');
  const keyValueArr = search.split('&');
  const query: { [propName: string]: string } = {};
  keyValueArr.forEach((keyValue) => {
    const [key, value] = keyValue.split('=');
    query[key] = decodeURIComponent(value);
  });
  return query;
};

/**
 * 获取浏览器版本
 * @returns
 */
export const browerVersion = () => {
  const { userAgent } = navigator;
  const userIdMatchs = userAgent.match(/userId\/(.*?) /);
  const weixinVersion = userAgent.match(/MicroMessenger\/([\d.]+)/i);
  return {
    mobile: !!userAgent.match(/AppleWebKit.*Mobile.*/),
    ios: !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
    android: userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1,
    iPhone: userAgent.indexOf('iPhone') > -1,
    iPad: userAgent.indexOf('iPad') > -1,
    weixin: userAgent.indexOf('MicroMessenger') > -1,
    myApp: userAgent.indexOf('pdmiryun') > -1,
    rmcb: userAgent.indexOf('rmcb') > -1,
    userId: userIdMatchs?.length ? userIdMatchs[1].replace(/ /g, '') : '',
    iframe: window.self !== window.top,
    windowWeixin: userAgent.indexOf('WindowsWechat') > -1,
    macWeixin: userAgent.indexOf('MacWechat') > -1,
    wxVersion: weixinVersion && weixinVersion.length ? weixinVersion[1] : 0,
    wxWork: userAgent.indexOf('WxWork') > -1,
    miniProgram: userAgent.indexOf('miniProgram') > -1,
  };
};

/**
 * 导入js文件
 * @param url
 * @param name
 * @returns
 */
export const loadScript = (url: string, name?: string) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    if (name) {
      const scriptElement = document.querySelector(`script[name="${name}"]`);
      if (scriptElement) {
        resolve(true);
        return;
      }
      script.setAttribute('name', name);
    }
    script.onload = () => {
      resolve(true);
    };
    script.onerror = (err) => {
      reject(err);
    };
    script.src = url;
    document.getElementsByTagName('html')[0].append(script);
  });
};
